(() => {
  const initializeSuccessModal = () => {
    const modal = document.querySelector('[data-oe-contact-success-modal]');
    if (!modal || modal.dataset.initialized === 'true') return;

    let responseFormId = '';
    try {
      responseFormId = decodeURIComponent(window.location.hash.slice(1));
    } catch (_error) {
      responseFormId = window.location.hash.slice(1);
    }

    if (responseFormId.startsWith('ContractRevocationForm-')) {
      modal.dataset.initialized = 'true';
      return;
    }

    const dialog = modal.querySelector('[role="dialog"]');
    const closeButtons = [...modal.querySelectorAll('[data-oe-contact-modal-close]')];
    const formTitle = document.querySelector('.oe-contact__form-title');
    const previouslyFocused = document.activeElement;

    if (!dialog || closeButtons.length === 0) return;

    modal.dataset.initialized = 'true';

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('oe-contact-modal-open');
      document.removeEventListener('keydown', handleKeydown);

      if (
        previouslyFocused instanceof HTMLElement &&
        previouslyFocused !== document.body &&
        previouslyFocused.isConnected
      ) {
        previouslyFocused.focus({ preventScroll: true });
      } else if (formTitle instanceof HTMLElement) {
        formTitle.setAttribute('tabindex', '-1');
        formTitle.focus({ preventScroll: true });
      }
    };

    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusableElements = closeButtons.filter((element) => !element.disabled);
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (!focusableElements.includes(document.activeElement)) {
        event.preventDefault();
        firstElement.focus();
      } else if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };

    closeButtons.forEach((button) => button.addEventListener('click', closeModal));
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', handleKeydown);

    modal.hidden = false;
    document.body.classList.add('oe-contact-modal-open');
    requestAnimationFrame(() => {
      dialog.focus({ preventScroll: true });

      try {
        const url = new URL(window.location.href);
        if (url.searchParams.get('contact_posted') === 'true') url.searchParams.delete('contact_posted');
        if (responseFormId === 'OfenerlebnisContactForm') url.hash = '';
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      } catch (_error) {
        // The confirmation remains usable if the URL cannot be cleaned up.
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSuccessModal, { once: true });
  } else {
    initializeSuccessModal();
  }

  document.addEventListener('shopify:section:load', initializeSuccessModal);
})();
